import React, { useCallback, useState } from 'react';

import Modal, { ModalTransition } from '@atlaskit/modal-dialog';

import { useLockScreenActions } from './LockScreenStore';
import { useAnalytics } from './Analytics';

export type LockScreenModalProps = {
	children: React.ReactNode;
};

export const LockScreenModal = ({ children }: LockScreenModalProps) => {
	const { fireAnalytics } = useAnalytics();
	const [isOpen, setIsOpen] = useState(true);
	const { unlockScreen } = useLockScreenActions();
	const closeModal = useCallback(() => {
		fireAnalytics({
			type: 'sendUIEvent',
			action: 'closed',
			actionSubject: 'modal',
			actionSubjectId: 'trialEndLockScreen',
		});

		setIsOpen(false);
	}, [fireAnalytics]);

	const handleCloseComplete = useCallback(() => {
		unlockScreen(true);
	}, [unlockScreen]);

	return (
		<ModalTransition>
			{isOpen && (
				<Modal
					// eslint-disable-next-line jsx-a11y/no-autofocus
					autoFocus={false}
					shouldScrollInViewport
					shouldCloseOnOverlayClick={false}
					onClose={closeModal}
					onCloseComplete={handleCloseComplete}
				>
					{children}
				</Modal>
			)}
		</ModalTransition>
	);
};
